import { render, staticRenderFns } from "./CRRichText.vue?vue&type=template&id=5e501987&scoped=true"
import script from "./CRRichText.vue?vue&type=script&lang=js"
export * from "./CRRichText.vue?vue&type=script&lang=js"
import style0 from "./CRRichText.vue?vue&type=style&index=0&id=5e501987&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e501987",
  null
  
)

export default component.exports